import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

import Radio from '../components/input/Radio'
import Select from '../components/input/Select'
import Number from '../components/input/Number'

const CardCompile = (props) => {
  let { formControls, handleChange, product } = props

  return (
    <div className="c-personalizer-card">

      <div className="c-personalizer-card__header">
        <h3 className="c-personalizer-card__title">1. Stel je mat samen</h3>
      </div>

      <div class="c-personalizer-row">
        <p class="c-personalizer-row__title">Waar komt je mat te liggen?</p>
        <Radio name="use"
          value={formControls.use.value}
          onChange={handleChange}
          options={formControls.use.options}
          touched={formControls.use.touched}
          valid={formControls.use.valid}
          error={formControls.use.error}
        />
      </div>

      <div class="c-personalizer-row">
        <p class="c-personalizer-row__title">Welke mat past bij jou?</p>

        { formControls.use.value ? (
          <Select name="type"
            placeholder={formControls.type.placeholder}
            value={formControls.type.value}
            onChange={handleChange}
            options={formControls.type.options}
            touched={formControls.type.touched}
            valid={formControls.type.valid}
            error={formControls.type.error}
          />
        ) : null }

        { formControls.type.value ? (
          <div>
            <p class="c-personalizer-row__label">Matdikte</p>
            <Radio name="thickness"
              value={formControls.thickness.value}
              onChange={handleChange}
              options={formControls.thickness.options}
              touched={formControls.thickness.touched}
              valid={formControls.thickness.valid}
              error={formControls.thickness.error}
            />
          </div>
        ) : null }

        { product && product.price === '' ? (
          <p className="c-personalizer-row__message">Let op. Vanwege de specificaties van deze mat is het niet mogelijk een richtprijs aan te geven. 
          Je ontvangt de vrijblijvende prijs na aanvraag.</p>
        ) : null }

        { formControls.thickness.value && product && product.rubber_edge.includes('Ja') ? (
          <div>
            <p class="c-personalizer-row__label">Randafwerking toevoegen?</p>
            <p class="c-personalizer-row__comment c-personalizer-row__comment--option">Komt de mat in een uitsparing in de vloer te liggen? Selecteer dan 'Nee'.</p>
            <Radio name="rubberEdge"
              value={formControls.rubberEdge.value}
              onChange={handleChange}
              options={formControls.rubberEdge.options}
              touched={formControls.rubberEdge.touched}
              valid={formControls.rubberEdge.valid}
              error={formControls.rubberEdge.error}
            />
          </div>
        ) : null }

      </div>

      <div class="c-personalizer-row">
        <p class="c-personalizer-row__title">Afmetingen</p>
        <p class="c-personalizer-row__comment">In cm tot 1 getal na de komma, bijv. 68,1 cm bij 100,2 cm.</p>

        <div class="u-flex u-flex-sb c-personalizer-row__row">
          <div class="c-personalizer-row__col">
            <Number name="length" 
              placeholder={formControls.length.placeholder}
              value={formControls.length.value}
              onChange={handleChange}
              touched={formControls.length.touched}
              valid={formControls.length.valid}
              step={formControls.length.validationRules.step}
              error={formControls.length.error}
            />
          </div>
          <div class="c-personalizer-row__col">
            <Number name="width" 
              placeholder={formControls.width.placeholder}
              value={formControls.width.value}
              onChange={handleChange}
              touched={formControls.width.touched}
              valid={formControls.width.valid}
              step={formControls.width.validationRules.step}
              error={formControls.width.error}
            />
          </div>
        </div>
      </div>

    </div>
  )
}

export default CardCompile



// WEBPACK FOOTER //
// ./src/js/personalizer/components/CardCompile.js